<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="content">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item" :class="pageType == 1 ? 'active' : ''" @click="pageType = 1">我的收藏</div>
          <div class="title-item" :class="pageType == 2 ? 'active' : ''" @click="pageType = 2">工单管理</div>
        </div>
        <contentCollectionComponent v-if="pageType == 1" />
        <contentGdComponent v-if="pageType == 2" />
      </div>
    </pcUserNavComponent>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'

import contentCollectionComponent from './ContentCollectionComponent.vue'
import contentGdComponent from './ContentGdComponent.vue'

export default {
  name: "User",
  components: {
    pcTabBarComponent,
    pcUserNavComponent,
    contentCollectionComponent,
    contentGdComponent
  },
  data() {
    return {
      pageType: 1,
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  watch: {
    '$route'(val) {
      if (val.name == 'Content' && val.query.pageType) {
        this.pageType = val.query.pageType
      }
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType
    }
  },
  methods: {
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
  overflow: hidden;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  .title-item {
    cursor: pointer;
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
</style>